<template>
  <div class="webinar-navbar">
    <div class="nav centered">
      <router-link :to="{ name: item.name }" :key="item.name" class="nav-item is-tab" active-class="is-active" v-for="item in userMenu">{{item.title}}</router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'WebinarsNavbar',
  data () {
    return {
      userMenu: []
    }
  },
  computed: {
    ...mapState(['menu', 'user'])
  },
  created () {
    this.userMenu = this.menu.webinars.filter(i => i.roles.includes(this.user.role))
  }
}
</script>



// WEBPACK FOOTER //
// WebinarNavbar.vue?a88535e2